export const DEFAULT_TABLE_HEIGHT = 200;

export const OVERSCAN = 20;

export const HEADER_BUFFER_LOADING = 72;

export const BOTTOM_BUFFER_HEIGHT = 300;

export const ROW_HEIGHT = 38;

export const BASE_TABLE_HEIGHT = 60;

export const NO_DATA_TABLE_HEIGHT = 78;

export const INITIAL_PAGE = 1;

export const FETCH_SIZE = 25;
